// Browser stub for Node.js 'module' module
export function createRequire() {
  return () => ({});
}

export default { createRequire };
